module.exports = "/virtual-football-league/img/video/clubs/italy/juventus.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/video/clubs/italy/juventus.png
// module id = 349
// module chunks = 4